import { makeStyles } from 'tss-react/mui';
import { GRAY_ALTERNATIVE, PRIMARY_PAYMENT_DEFAULT } from "src/global/theme/colors";

export const styles = makeStyles()(() => {
  return {
    tableHeader: {
      padding: "24px 0",
      width: '100%',
      borderRadius: '6px 6px 0 0',
      backgroundColor: PRIMARY_PAYMENT_DEFAULT,
      color: GRAY_ALTERNATIVE,
      alignItems: 'center',
    },
  };
});
